import { AfterContentChecked, AfterViewInit, Component, ErrorHandler, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { LaskuService } from '../../_angular/service/lasku/lasku.service'
import { FormValidationService } from '../../_jaettu-angular/service/form-validation.service'

import { LaskunListaustietorivi } from '@lemon/core-firebase/model/lasku'
import { LaskuSharedService } from '@lemon/core-firebase/service/lasku/lasku-shared.service'
import { CurrencyService } from '@lemon/core/service/currency.service'

export interface LaskuHaluatkoVarmastiPeruaMaksetuksiMerkitsemisenDialogData {
  rivi: LaskunListaustietorivi
}

@Component({
  selector: 'lasku-haluatko-varmasti-perua-maksetuksi-merkitsemisen-dialog',
  templateUrl: './lasku.haluatko-varmasti-perua-maksetuksi-merkitsemisen.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LaskuHaluatkoVarmastiPeruaMaksetuksiMerkitsemisenDialog implements OnInit, AfterViewInit, AfterContentChecked {
  private _buttonPushInflight: boolean = false

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: LaskuHaluatkoVarmastiPeruaMaksetuksiMerkitsemisenDialogData,
    private dialogRef: MatDialogRef<LaskuHaluatkoVarmastiPeruaMaksetuksiMerkitsemisenDialog>,
    private validationService: FormValidationService,
    private laskuService: LaskuService,
    private errorHandler: ErrorHandler,
    private sharedLaskuService: LaskuSharedService,
    private currencyService: CurrencyService,
  ) {}

  ngAfterContentChecked() {}

  ngOnInit() {}

  ngAfterViewInit() {}

  async peru() {
    if (this._buttonPushInflight) {
      return
    }
    this._buttonPushInflight = true

    try {
      const result = await this.laskuService.merkitseLaskuTaysinMaksetuksi(this.data.rivi)
      this.dialogRef.close(result)
    } catch (error) {
      this.errorHandler.handleError(error)
    } finally {
      this._buttonPushInflight = false
    }
  }
}
